<template>
        <div>
            <b>{{title}}:</b>
            <b-form-checkbox-group 
                v-model="selected" 
                :options="checkboxOptions" 
                class=""
            >
            </b-form-checkbox-group>
        </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue'

    const props = defineProps({
        title: {required: false, default: "", type: String},
        initOptions: {required: false, default: () => [], type: Array},
        initSelected: {required: false, default: () => [], type: Array},
    });

    // onMounted(() => {
    //     console.log(`DataTableCheckboxFilter Component mounted.`);
    // });

    const checkboxOptions = ref(props.initOptions);
    const selected = ref(props.initSelected);

    const emit = defineEmits(['input']);

    watch(
    () => props.selected,
        (newVal) => {
            emit('input', newVal);
        }
    );
</script>
